import { render, staticRenderFns } from "./ProGroup.vue?vue&type=template&id=6d90698f&scoped=true"
import script from "./ProGroup.vue?vue&type=script&lang=js"
export * from "./ProGroup.vue?vue&type=script&lang=js"
import style0 from "./ProGroup.vue?vue&type=style&index=0&id=6d90698f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90698f",
  null
  
)

export default component.exports